
import { 
    postData, getData, destroyData
} from '@/store/config/method'

const requestInit = {
    page: 1,
    show: 10,
    sortBy: null,
    sorting: null,
    search: null,
}
const mainItemInit = {
    id: null,
    accreditation: null,
    icon_id: null,
    full_path: null,
    filename: null,
    mime_type: null,
    file_size: null,
    name_short: null,
    name_long: null,
    order: null,
    is_active: true,
    edu_level_data: []
}
const contentItemInit = {
    id: null,
    file_id: null,
    full_path: null,
    filename: null,
    mime_type: null,
    file_size: null,
    description: null,
    vission_mission: null
}
const registrationItemInit = {
    id: null,
    registration_picture_id: null,
    full_path: null,
    filename: null,
    mime_type: null,
    file_size: null,
    registration_title: null,
    registration_subtitle: null,
    registration_is_active: false,
}
const initialState = () => ({
    message: null,
    status: 0,
    meta: {},
    data: [],
    request: {...requestInit},
    mainItem: {...mainItemInit},
    contentItem: {...contentItemInit},
    registrationItem: {...registrationItemInit},
    list: []
})
const state = initialState
 
const getters = {
    getMessage: state => state.message,
    getStatus: state => state.status,
    getData: state => state.data || [],
    getMeta: state => state.meta || {},
    getRequest: state => state.request,
    getMainItem: state => state.mainItem || {},
    getContentItem: state => state.contentItem || {},
    getRegistrationItem: state => state.registrationItem || {},
    getList: state => state.list
}

const actions = {
    resetRequest({commit}){
        commit('SET_REQUEST',{...requestInit})
    },
    resetMainItem({commit}){
        commit('SET_MAIN_ITEM',{...mainItemInit, edu_level_data: []})
    },
    setMainItem({commit}, value){
        commit('SET_MAIN_ITEM',{...value})
    },

    async submit({
        commit
    }, {data, path = '/main'}) {
        try {
            const payload = {...data}
            delete payload.id
            const url = `/education-unit${path}`
            const response = await postData('api',url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({
        commit, state
    }){
        try {
            const response = await getData('api','/education-unit/main',{params: state.request});
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getDetail({
        commit
    }, {slug, type = 'main'}){
        try {
            const url = `/education-unit/${type}/${slug}`
            const response = await getData('api',url);
            commit('SET_RESPONSE', response.data);
            if(type == 'main') commit('SET_MAIN_ITEM', {...response.data.data, edu_level_data: []});
            else if(type == 'content') commit('SET_CONTENT_ITEM', response.data.data);
            else if(type == 'registration') commit('SET_REGISTRATION_ITEM', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async update({
        commit
    }, data) {
        try {
            const url = `/education-unit/main/${data.id}`
            const payload = {
                ...data
            }
            delete payload.id
            const response = await postData('api',url,payload);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    
    async destroy({
        commit
    }, data) {
        try {
            const url = `/education-unit/main/${data.id}`
            const response = await destroyData('api',url);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.message = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        if(error.status == 400){
            state.message = error.data.message
            state.status = error.data.status
        }else{
            state.message = 'Jaringan Bermasalah'
            state.status = 0
        }
    },
    SET_RESPONSE(state, response) {
        state.message = response.message
        state.status = response.status
    },
    SET_DATA(state, response) {
        state.data = response.data
        state.meta = {
            current_page: response.current_page,
            from: response.from,
            last_page: response.last_page,
            per_page: response.per_page,
            to: response.to,
            total: response.total
        }
    },
    SET_LIST(state, value) {
        state.list = value
    },
    SET_REQUEST(state, value){
        state.request = value
    },
    SET_MAIN_ITEM(state, value){
        state.mainItem = value
    },
    SET_CONTENT_ITEM(state, value){
        state.contentItem = value
    },
    SET_REGISTRATION_ITEM(state, value){
        state.registrationItem = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}